import cloneDeep from "lodash/cloneDeep";
import orderBy from "lodash/orderBy";
import { arrayCount } from "@/js/utils";

export class FacilityTranslator {
  static toEveMunicipalitiesAndEveAreasFromEvaAreaInfo(evaAreaInfo) {
    const CODE = {
      KEY: "key",
      MUNICIPALITY: "municipalityCode",
      AREA: "areaCode"
    };
    const municipalityCodeList = [];
    const areaCodeList = [];
    if (arrayCount(evaAreaInfo) > 0) {
      const clonedEvaAreaInfo = cloneDeep(evaAreaInfo);
      clonedEvaAreaInfo.forEach(info => {
        info[CODE.MUNICIPALITY] = Number(info.eva_municip_code);
        info[CODE.AREA] = Number(info.eva_area_code);
      });
      const sortedEvaAreaInfo = orderBy(clonedEvaAreaInfo, [
        CODE.MUNICIPALITY,
        CODE.AREA
      ]);
      sortedEvaAreaInfo.forEach((info, index) => {
        info[CODE.KEY] = index + 1;
        municipalityCodeList.push(info.eva_municip_code);
        areaCodeList.push(info.eva_area_code);
      });
      sortedEvaAreaInfo.forEach(info => {
        delete info[CODE.MUNICIPALITY];
        delete info[CODE.AREA];
      });
      evaAreaInfo = cloneDeep(sortedEvaAreaInfo);
    }
    return {
      eva_area_info: evaAreaInfo,
      eva_municip_code_list: municipalityCodeList,
      eva_area_code_list: areaCodeList
    };
  }
}
